import React, { Component } from 'react';
import './Buttons.css'

class ButtonComprar extends Component {
    render() {
        return(
            <button className='btn btn-comprar' type="submit">COMPRAR</button>
        )
    }
}

export default ButtonComprar;